import { createContext, useContext } from 'react';
import { Logger } from 'loglevel';

export interface LoggerContextType {
  logger: Logger;
}

export const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

export const useLogger = (): Logger => {
  const context = useContext(LoggerContext);
  if (!context) {
    throw new Error('useLogger doit être utilisé dans un LoggerProvider');
  }
  return context.logger;
};
